import { Button, Image, Input } from 'antd'
import React, { useEffect } from 'react'
import { View } from 'styles/reactnative'

const PopUpImage = ({ images, setImages }) => {
	const [length, setLength] = React.useState(images?.length || 1)

	const [tempimage, setTempImage] = React.useState(new Map())
	const [refresh, setRefresh] = React.useState(false)

	useEffect(() => {
		//to Array
		const temp = Array.from(tempimage.values())
		temp.forEach((value, index) => {
			if (value === '') {
				temp.splice(index, 1)
			}
		})
		setImages(temp)
	}, [tempimage, refresh])

	// const onChange: UploadProps['onChange'] = (file: any) => {
	// 	setImages(file?.fileList)
	// }

	// const onPreview = async (file: UploadFile) => {
	// 	let src = file.url as string
	// 	if (!src) {
	// 		src = await new Promise(resolve => {
	// 			const reader = new FileReader()
	// 			reader.readAsDataURL(file.originFileObj as RcFile)
	// 			reader.onload = () => resolve(reader.result as string)
	// 		})
	// 	}
	// 	const image = new Image()
	// 	image.src = src
	// 	const imgWindow = window.open(src)
	// 	imgWindow?.document.write(image.outerHTML)
	// }

	return (
		<View
			style={{
				height: 130,
				width: '100%',
				borderBottom: '1px solid #ddd',
				padding: 3,
				overflow: 'auto',
				justifyContent: 'space-between',
				alignItems: 'flex-start',
			}}>
			{Array.from({ length: length }).map((_, index) => (
				<View
					style={{
						flexDirection: 'row',
						justifyContent: 'space-between',
						borderBottom: `1px solid #ddd`,
						padding: 3,
						width: '100%',
						alignItems: 'center',
					}}>
					<Input
						style={{ width: '80%', flex: 1 }}
						key={index}
						onChange={e => {
							setTempImage(tempimage.set(index, e.target.value))
							setRefresh(!refresh)
						}}
					/>
					{tempimage.get(index) && (
						<Image
							src={tempimage.get(index)}
							style={{ width: '30px', height: '30px' }}
						/>
					)}
				</View>
			))}

			<Button onClick={() => setLength(length + 1)}>Add</Button>
			{/* <Upload
				name="avatar"
				listType="picture-card"
				className="avatar-uploader"
				fileList={images}
				onChange={onChange}
				beforeUpload={beforeUpload}
				style={{
					borderColor: 'blue',
				}}
				onPreview={onPreview}
				multiple={true}>
				{images.length < 4 && '+ Upload'}
			</Upload> */}
		</View>
	)
}

export default PopUpImage
